import React, { useMemo, useState } from 'react';
import './App.css';
import AppRouter from './AppRouter';
import { SidebarProvider } from './components/SidebarContext';
import { ReactFlowProvider } from 'reactflow';
import { NotificationProvider } from './components/NotificationContext';
import SubscriptionRedirect from './components/SubscriptionRedirect';
import Sidebar from './components/Sidebar';
import NavBar from './components/Navbar';
import AppErrorBoundary from './components/AppErrorBoundary';
import AccountHealthBanner from './components/AccountHealthBanner';
import './i18n';
import { Link, useLocation } from 'react-router-dom';
import { useSidebar } from './components/SidebarContext';
import { FaRobot } from 'react-icons/fa';

import FooterComponent from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

function CampaignAgentShortcut() {
  const location = useLocation();
  const campaignId = useMemo(() => {
    const match = location.pathname.match(/^\/campaigns\/([^/]+)$/);
    return match?.[1] || null;
  }, [location.pathname]);

  if (!campaignId) return null;

  return (
    <Link
      to={`/campaigns/${campaignId}/agent`}
      className="fixed right-6 bottom-24 z-[80] inline-flex items-center gap-2 rounded-full bg-blue-600 px-5 py-3 text-sm font-semibold text-white shadow-lg transition hover:bg-blue-700"
      aria-label="Open AI Sales Agent voor deze campagne"
    >
      <FaRobot />
      AI Sales Agent
    </Link>
  );
}

function AppLayout({ children, notificationStatus, shouldHideLayout }) {
  const { collapsed } = useSidebar();

  return (
    <div className="App flex">
      {!shouldHideLayout && <Sidebar />}

      <div
        className={`flex flex-col min-h-screen w-full transition-all bg-gray-100 overflow-x-hidden
        ${!shouldHideLayout ? (collapsed ? 'lg:ml-16' : 'lg:ml-64') : ''}`}
      >
        {!shouldHideLayout && <NavBar notificationStatus={notificationStatus} />}
        <main className="flex-grow pt-20 bg-white">
          {!shouldHideLayout && <AccountHealthBanner />}
          {children}
        </main>
        <CampaignAgentShortcut />
        <FooterComponent />
      </div>
    </div>
  );
}

function App() {
  const [notificationStatus, setNotificationStatus] = useState(null);
  const location = useLocation();
  const hideLayoutRoutes = ['/login', '/register', '/reset-password', '/set-password', '/confirmation'];
  const shouldHideLayout = hideLayoutRoutes.includes(location.pathname);

  return (
    <AppErrorBoundary key={location.pathname}>
      <NotificationProvider>
        <ReactFlowProvider>
          <SubscriptionRedirect />
          <SidebarProvider>
            {shouldHideLayout ? (
              <AppRouter setNotificationStatus={setNotificationStatus} />
            ) : (
              <AppLayout
                notificationStatus={notificationStatus}
                shouldHideLayout={shouldHideLayout}
              >
                <ScrollToTop />
                <AppRouter setNotificationStatus={setNotificationStatus} />
              </AppLayout>
            )}
          </SidebarProvider>
        </ReactFlowProvider>
      </NotificationProvider>
    </AppErrorBoundary>
  );
}

export default App;
